<template>
  <v-card class="mt-2 table-card" outlined>
    <v-container fluid>
      <v-row class="mx-3 mb-3">
        <v-col cols="7" class="d-flex justify-start">
          <h2>{{ $t('title_ClubMembers') }}</h2>
          <v-btn :color="`#${$store.state.clubMember.club.primaryColor} !important`" style="color:#FFFFFF !important" v-if="pendingMembers.length > 0 && this.$store.state.clubMember.rol !== 'MEMBER'"
                 class="ml-5 mt-n1 request-button" @click="openNewRequests">{{ pendingMembers.length }} {{ $tc('request', pendingMembers.length) }}</v-btn>
        </v-col>
        <v-col cols="5">
          <v-text-field class="mt-n2" :placeholder="$t('searchPlaceholder')" append-icon="fa-search" v-model="search" single-line hide-details/>
        </v-col>
      </v-row>
      <v-row v-if="$store.state.clubMember.rol !== 'MEMBER'" align="center" justify="center">
        <v-icon class="mt-n5 mr-2" small>fa-upload</v-icon><p style="cursor: pointer; color: #585a61" @click="openImportMembers">{{ $t('importMembers') }}</p>
      </v-row>
      <v-data-table style="background-color: rgba(0,0,0,0)" :loading="loadingMembers" :loading-text="$t('table_ClubMembers.loading')"  
                    :items="membersToVisualize" :headers="headers" :search="search"
                    :show-expand="$store.state.clubMember.rol !== 'MEMBER'" single-expand>
        <template v-slot:item.userPhoto="{ item }">
          <v-avatar size="40">
            <v-img :src="item.user.imageUrl !== null? item.user.imageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"></v-img>
          </v-avatar>
        </template>
        <template v-slot:item.user.firstName="{ item }">
          <p class="mb-0" style="font-size: 14px;">{{ item.user.firstName }}</p>
        </template>
        <template v-slot:item.user.lastName="{ item }">
          <p class="mb-0" style="font-size: 14px;">{{ item.user.lastName }}</p>
        </template>
        <template v-slot:item.rol="{ item }">
          <v-chip color="#00F784" v-if="item.rol === 'FOUNDER'" small><p style="font-size: 13px;" class="mb-0">{{ getRol(item) }} <v-icon class="ml-1 mb-1" x-small>fa-star</v-icon></p></v-chip>
          <v-chip color="#FFF75F" v-else-if="item.rol === 'ADMIN'" small><p style="font-size: 13px;" class="mb-0">{{ getRol(item) }} <v-icon class="ml-1 mb-1" x-small>fa-user-shield</v-icon></p></v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-chip v-if="item.rol === 'PENDING'" color="#EF5350" @click="openNewRequests" small><p style="font-size: 13px;" class="mb-0">
            {{ $t('roles.pending') }} <v-icon class="ml-1" x-small>fa-user-plus</v-icon></p></v-chip>
          <v-chip v-else-if="item.user.id !== $store.state.user.id" @click="seeJournal(item)" small><p style="font-size: 13px;" class="mb-0">
            {{ $t('table_ClubMembers.btnSeeJournal') }}<v-icon class="ml-2" x-small>fa-stream</v-icon></p></v-chip>
          <v-chip v-if="item.rol !== 'PENDING' && item.user.id !== $store.state.user.id" @click="memberOptions(item)" class="ml-2" small><p style="font-size: 13px;" class="mb-0">
            {{ $t('table_ClubMembers.btnOptions') }} <v-icon class="ml-1" x-small>fa-ellipsis-v</v-icon></p></v-chip>
        </template>

        <template v-slot:item.data-table-expand="{ expand, isExpanded }">
          <v-icon class="icon" @click="expand(!isExpanded)" small>{{ (isExpanded)? 'fa-angle-up' : 'fa-angle-down' }}</v-icon>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <ClubMemberPerformance :member="item"/>
          </td>
        </template>
      </v-data-table>
    </v-container>

    <!-- Overlay for new requests !-->
    <v-overlay :dark="false" v-model="overlaySeeRequests">
      <SeeRequests :pending-members="pendingMembers" @closeWindow="overlaySeeRequests = false"/>
    </v-overlay>

    <!-- Overlay for import members !-->
    <v-overlay :dark="false" v-model="overlayImportMembers">
      <ImportMembers @closeWindow="overlayImportMembers = false"/>
    </v-overlay>

    <!-- Overlay for member options !-->
    <v-overlay :dark="false" v-model="overlayMemberOptions">
      <MemberOptions :member="currentMember" @closeWindow="overlayMemberOptions = false"/>
    </v-overlay>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import SeeRequests from "@/views/Community/components/SeeRequests";
import { mapMutations } from 'vuex';
import MemberOptions from "@/views/Community/components/MemberOptions";
import ClubMemberPerformance from "@/views/Community/components/ClubMemberPerformance";
import ImportMembers from "@/views/Community/components/ImportMembers";

export default {
  name: "ClubMembers",
  components: {ImportMembers, ClubMemberPerformance, MemberOptions, SeeRequests},
  data() {
    return {
      loadingMembers: true,
      overlaySeeRequests: false,
      overlayImportMembers: false,
      overlayMemberOptions: false,
      search: '',
      currentMember: null,
      membersToVisualize: [],
      pendingMembers: [],
      headers: [
        { text: this.$t('table_ClubMembers.profile'), align: 'left', value: 'userPhoto', sortable: false, filterable: false, },
        { text: this.$t('table_ClubMembers.firstName'), align: 'left', value: 'user.firstName', },
        { text: this.$t('table_ClubMembers.lastName'), align: 'left', value: 'user.lastName', },
        { text: this.$t('table_ClubMembers.rol'), align: 'left', value: 'rol', sortable: true, filterable: false, },
      ],
    };
  },
  watch: {
    '$store.state.clubMembers': function () {
      this.membersToVisualize = (this.$store.state.clubMember.rol === 'MEMBER')? this.$store.state.clubMembers.filter((member) => member.rol !== 'PENDING') : this.$store.state.clubMembers;
      this.seePendingRequests();
      this.loadingMembers = false;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(['setClubMembers']),
    init() {
      if(this.$store.state.clubMember.rol !== 'MEMBER')
        this.headers.push({ text: this.$t('table_ClubMembers.actions'), align: 'right', value: 'actions', sortable: false, filterable: false, });

      Repository.getAllClubMembers(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400) {
          this.setClubMembers(response.data);
          this.membersToVisualize = (this.$store.state.clubMember.rol === 'MEMBER')? response.data.filter((member) => member.rol !== 'PENDING') : response.data;
          this.seePendingRequests();
          this.loadingMembers = false;
        }
      });
    },
    getRol(member) {
      return (member.rol === 'FOUNDER')? this.$t('roles.founder') :
          (member.rol === 'ADMIN')? this.$t('roles.admin') : this.$t('roles.member');
    },
    openNewRequests() {
      this.overlaySeeRequests = true;
    },
    openImportMembers() {
      this.overlayImportMembers = true;
    },
    seePendingRequests() {
      this.pendingMembers = [];
      this.$store.state.clubMembers.forEach((member) => {
        if(member.rol === 'PENDING')
          this.pendingMembers.push(member);
      });
    },
    ...mapMutations(['setShare']),
    seeJournal(member) {
      let sharingDetails = {
        id: member.user.id,
        username: member.user.login,
        imageUrl: member.user.imageUrl,
        firstName: member.user.firstName,
        lastName: member.user.lastName,
        country: member.user.country,
        allowComments: false,
      };
      this.setShare(sharingDetails);
      this.$router.push('/book/shared');
    },
    memberOptions(member) {
      this.currentMember = member;
      this.overlayMemberOptions = true;
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
  },
}
</script>



<style scoped>
  .request-button {
    background-color: #EF5350 !important;
    font-size: 14px !important;
    color: #ffffff !important;
    border: #EF5350 solid 2px !important;
  }
</style>
